<template lang="pug">
v-layout.mt-4.flex-column-phablet
  v-progress-linear(indeterminate, v-if='!initialized')
  v-layout(column, v-else)
    h2 Notificaties & meldingen personaliseren
    span Bij elk ontvangen aanvraag kan je een SMS-bericht of E-mail versturen naar zowel jezelf als naar de klant. Met een SMS bericht kan je sneller handelen en laat je je klant weten dat de aanvraag in behandeling is genomen.

    //- TODO disable save if $invalid

    v-layout.flex-column-phone
      v-layout(column)
        .ml-0.mr-0.mt-5
          h3.bold Berichten naar klanten

          v-expansion-panel.elevation-0
            template(v-for='m in notificationMethodsCustomer')
              NotificationEmail(v-if='m.method === "email"', :value='m', :isDealer='false')

              NotificationSms(v-if='m.method === "sms"', :value='m', :isDealer='false')

          v-divider.mt-4

        .ml-0.mr-0.mt-2
          h3.bold Berichten naar dealers
          p Je kan de dealer, indien deze gekoppeld is, ook een notificatie sturen.

          v-expansion-panel.elevation-0
            template(v-for='m in notificationMethodsDealer')
              NotificationEmail(v-if='m.method === "email"', :value='m', :isDealer='true')

              NotificationSms(v-if='m.method === "sms"', :value='m', :isDealer='true')

      v-layout.ml-4(align-start, column)
        KeyValueTable(:data='personalisationCodes', title='Personalisatie codes')
</template>

<script>
export default {
  name: 'Notifications',

  components: {
    NotificationEmail: require('./NotificationEmail').default,
    NotificationSms: require('./NotificationSms').default,
    KeyValueTable: require('@/components/KeyValueTable').default
  },

  data () {
    return {
      loading: false,
      initialized: false,
      notificationMethodsCustomer: [],
      notificationMethodsDealer: [],
      personalisationCodes: [
        ['Domeinnaam', '{websiteprofiel}'],
        ['Soort aanvraag', '{soort_aanvraag}'],
        ['Productsoort', '{product_soort}'],
        ['Bedrag', '{product_bedrag}'],
        ['AanvraagID', '{aanvraag_id}'],
        ['Klantnaam', '{naam}'],
        ['Klant telefoon', '{klant_telefoon}'],
        ['Dealer bedrijfsnaam', '{dealer_bedrijfsnaam}'],
        ['Dealer contactpersoon', '{dealer_contactpersoon}'],
        ['Dealer telefoon', '{dealer_telefoon}'],
        ['Organisatie bedrijfsnaam', '{organisatie_bedrijfsnaam}'],
        ['Support telefoon', '{support_telefoon}']
      ]
    }
  },

  methods: {
    async save () {
      this.loading = true

      try {
        await this.$store.dispatch('graphqlMutation', {
          name: 'setNotificationMethods',
          variables: {
            orgId: this.$store.state.organization.currentOrgId,
            notificationMethodsCustomer: this.notificationMethodsCustomer,
            notificationMethodsDealer: this.notificationMethodsDealer
          },
          deleteCacheQueries: ['getNotificationMethods']
        })

        this.$root.$snackbar.show('Personalisatie gewijzigd')
      } catch (error) {
        console.error(error)

        this.$root.$snackbar.show('Personalisatie NIET gewijzigd')
      }

      this.loading = false
    }
  },

  async created () {
    this.loading = true

    const notificationMethods = await this.$store.dispatch('graphqlQuery', {
      name: 'getNotificationMethods',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    })

    this.notificationMethodsCustomer = notificationMethods.notificationMethodsCustomer
    this.notificationMethodsDealer = notificationMethods.notificationMethodsDealer

    this.loading = false

    this.initialized = true

    for (const key of ['notificationMethodsCustomer', 'notificationMethodsDealer']) {
      this.$watch(key, () => {
        this.$root.$save.show(this.save, null)
      }, { deep: true })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
